import React from 'react';
import { ReportsSubscribeSC, LoadingWrapper } from './reports-subscribe.styled';
import { FormattedMessage } from 'react-intl';
import dlt from '../../../../../utils/default-lang';
import { SmallText } from '../../../../typography';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as Actions from '../../../../../redux/action';
import InlineLoading from '../../../../ui/inline-loading';

const ReportsSubscribe = ({ isSubscribed, changeMailboxReportsSubscription, loading }) => {
  return (
    <div
      style={{ display: 'flex', width: '100%', alignItems: 'center', justifyContent: 'flex-end' }}
    >
      <ReportsSubscribeSC>
        <SmallText className="selector-text">
          <FormattedMessage
            id="mailbox_reports_subscribe_label"
            defaultMessage={dlt['mailbox_reports_subscribe_label']}
          />
        </SmallText>
        {loading ? (
          <LoadingWrapper>
            <InlineLoading />
          </LoadingWrapper>
        ) : (
          <div className="tab-wrapper">
            <button
              key={'b1'}
              className={isSubscribed ? 'active' : ''}
              onClick={isSubscribed ? null : () => changeMailboxReportsSubscription(true)}
            >
              <FormattedMessage
                id="mailbox_reports_subscribe_subscribed"
                defaultMessage={dlt['mailbox_reports_subscribe_subscribed']}
              />
            </button>
            <button
              key={'b2'}
              className={isSubscribed ? '' : 'active'}
              onClick={isSubscribed ? () => changeMailboxReportsSubscription(false) : null}
            >
              <FormattedMessage
                id="mailbox_reports_subscribe_unsubscribed"
                defaultMessage={dlt['mailbox_reports_subscribe_unsubscribed']}
              />
            </button>
          </div>
        )}
      </ReportsSubscribeSC>
    </div>
  );
};

ReportsSubscribe.propTypes = {};

const mapStateToProps = (state) => ({
  isSubscribed: !!state.user.send_reports,
  loading: state.mailbox.reportSubscriptionLoading,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      changeMailboxReportsSubscription: Actions.changeMailboxReportsSubscription,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(React.memo(ReportsSubscribe));
